// components/LandingPage.jsx

import React from "react";
import Header from "./Header";
import Hero from "./Hero";
import SignatureSection from "./SignatureSection";
import AboutSectionWrapper from "./AboutSectionWrapper";
import GallerySection from "./GallerySection";
import ReservationSection from "./ReservationSection";
import ContactSection from "./ContactSection";
import Footer from "./Footer";

export default function LandingPage() {
  return (
    <>
      <Header />
    
      <Hero />

      <SignatureSection />

      <AboutSectionWrapper />

      <GallerySection />

      <ReservationSection />

      <ContactSection />

      <Footer />
    </>
  );
}